function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { set } from '@ember/object';
import Service from '@ember/service';
import { setUserData } from '@square/dashboard-utilities/utils/window';

// Add known current user values to the Data type so it can be type checked

export default class CurrentUserData extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "data", {});
  }
  setup(incomingData) {
    set(this, 'data', incomingData);
    Object.freeze(this.data);
    setUserData(incomingData);
  }
}

// This is how TypeScript knows how to look up the service.
/** @hidden */